import type { DemoModel } from "./models";

const WORK_KEY = "scans.workMode";

function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed || "/";
}

export function isWorkPath(pathname = window.location.pathname): boolean {
  return normalizePath(pathname) === "/work";
}

export function initWorkMode(): boolean {
  const path = normalizePath(window.location.pathname);
  if (path === "/work") {
    sessionStorage.setItem(WORK_KEY, "1");
    ensureWorkUrl();
    return true;
  }
  if (path === "/" || path === "/index.html") {
    sessionStorage.removeItem(WORK_KEY);
    return false;
  }
  if (isWorkMode()) {
    ensureWorkUrl();
    return true;
  }
  return false;
}

export function isWorkMode(): boolean {
  return sessionStorage.getItem(WORK_KEY) === "1";
}

export function workLinkUrl(): string {
  return `${window.location.origin}/work`;
}

export function isPubliclyVisible(model: DemoModel, workMode = isWorkMode()): boolean {
  if (model.hidden) {
    return false;
  }
  if (workMode && model.nsfw) {
    return false;
  }
  return true;
}

/** Keep `/work` in the address bar for the whole work session. */
export function ensureWorkUrl(): void {
  if (!isWorkMode()) {
    return;
  }
  const url = new URL(window.location.href);
  if (normalizePath(url.pathname) === "/work") {
    return;
  }
  url.pathname = "/work";
  history.replaceState(null, "", url);
}

export function withWorkPath(url: URL): void {
  if (isWorkMode() || isWorkPath()) {
    url.pathname = "/work";
  }
}

export function commitAppUrl(url: URL): void {
  withWorkPath(url);
  history.replaceState(null, "", url);
  ensureWorkUrl();
}

export function bindWorkModeHistory(): void {
  window.addEventListener("popstate", () => {
    const path = normalizePath(window.location.pathname);
    if (path === "/" || path === "/index.html") {
      if (isWorkMode()) {
        sessionStorage.removeItem(WORK_KEY);
        window.dispatchEvent(new CustomEvent("scans-work-mode"));
      }
      return;
    }
    if (isWorkPath()) {
      sessionStorage.setItem(WORK_KEY, "1");
      ensureWorkUrl();
      window.dispatchEvent(new CustomEvent("scans-work-mode"));
      return;
    }
    if (isWorkMode()) {
      ensureWorkUrl();
    }
  });
}
